module.exports = __webpack_public_path__ + "img/renault.29c6e5dd.svg";